module.exports = __webpack_public_path__ + "static/media/icon-filters.c81cf036.svg";